import { postXenditPayment } from 'api/xendit'
import React from 'react'
import { useMutation } from 'react-query'
import { showErrorMessage, showSuccessMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'

const useXendit = () => {
  const submitPay = useMutation({
    mutationKey: 'postSubmitXenditPayment',
    mutationFn: (payload) => postXenditPayment(payload),
    onSuccess: () => {
      showSuccessMessage('Ref. Id telah dibayar')
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })
  const handlePay = (refId, totalAmount) => {
    const payload = {
      ref_id: refId,
      body: {
        amount: totalAmount
      }
    }

    submitPay.mutate(payload)
  }
  return {
    handlePay,
    isPaymentLoading: submitPay?.isLoading
  }
}

export default useXendit
